Vue.component('makeAppointment', {
    data() {
        return {
            root: this.$root,
            appointmentType: '',
            datepicker: null,
            makeAppointment: false,
            unavailableError: false,
            sortedShopList: [],
            appointmentTypes: [],
            availableDays: [],
            availableTimes: [],
            selectedTime: null,
            showAppointmentTypes: false,
            showDatepicker: false,
            appointment: {
                CustomerNumber: '',
                AgendaId: '',
                AppointmentType: '',
                AppointmentTypeId: '',
                Date: '',
                StartTime: '',
                EndTime: '',
                Email: document.forms['make-appointment-form'].elements.Email.value,
                ResourceId: null,
                FirstName: document.forms['make-appointment-form'].elements.FirstName.value,
                LastName: document.forms['make-appointment-form'].elements.LastName.value,

                Street: document.forms['make-appointment-form'].elements.Street.value,
                HouseNumber: document.forms['make-appointment-form'].elements.HouseNumber.value,
                HouseNumberAddition: document.forms['make-appointment-form'].elements.HouseNumberAddition.value,
                City: document.forms['make-appointment-form'].elements.City.value,
                Country: document.forms['make-appointment-form'].elements.Country.value,
                ChecklistQuestions: document.forms['make-appointment-form'].elements.ChecklistQuestions.value,

                PageId: null
            },
            currentQuestion: 1,
            showOverview: false,
            checklistQuestions: checklistQuestionsGlobal,
        };
    },
    mounted() {
        if (document.forms['make-appointment-form'].elements.CustomerNumber.hasAttribute('data-value')) {
            // Channel marketing
            this.appointment.CustomerNumber = document.forms['make-appointment-form'].elements.CustomerNumber.getAttribute('data-value');
        } else {
            // Regular website
            this.appointment.CustomerNumber = document.forms['make-appointment-form'].elements.CustomerNumber.value;
        }

        this.datepicker = flatpickr(document.querySelector('.js-datepicker'), {
            locale: document.documentElement.lang.split('-')[0],
            altInput: true,
            altFormat: 'j F Y',
            inline: true,
            enableTime: false,
            minDate: 'today',
            time_24hr: true,
            onMonthChange: (selectedDates, dateStr, instance) => {
                this.getBookableDays(this.appointment.AppointmentTypeId);
            },
            onYearChange: (selectedDates, dateStr, instance) => {
                this.getBookableDays(this.appointment.AppointmentTypeId);
            },
            onChange: (selectedDates, dateStr, instance) => {
                const agendaId = this.availableDays.filter(d => d.date === dateStr)[0].agendaId;
                const appointmentTypeId = this.availableDays.filter(d => d.date === dateStr)[0].appointmentTypeId;

                this.appointment.StartTime = '';
                this.appointment.EndTime = '';
                this.appointment.ResourceId = null;

                this.appointment.AgendaId = agendaId;
                this.appointment.AppointmentTypeId = appointmentTypeId;
                this.appointment.Date = dateStr;

                this.getBookableTimes(agendaId, dateStr, appointmentTypeId);
            },
        });

        if (document.forms['make-appointment-form'].elements.Shop.querySelector('[selected]')) {
            this.appointment.CustomerNumber = document.forms['make-appointment-form'].elements.Shop.querySelector('[selected]').value;
        }

        //if (website.loggedIn) {
        //    this.setFormFieldsReadonly();
        //}

        //this.initFormFill();

        // Set 'givenAnwser' property for each question
        this.checklistQuestions.forEach((question) => {
            Vue.set(question, 'givenAnswer', null);
            Vue.set(question, 'givenAnswerMulti', []);
        });

    },
    computed: {
        activeQuestion() {
            return this.checklistQuestions[this.currentQuestion - 1];
        },

        checklistQuestionsString() {
            var s = "";
            this.checklistQuestions.forEach((question) => {
                if (question.givenAnswerMulti && question.givenAnswerMulti.length > 0) {
                    s += question.givenAnswerMulti.join('#') + ",";
                } else {
                    s += question.givenAnswer + ",";
                }
            });

            return s;
        }
    },
    watch: {
        'appointment.CustomerNumber': function (customerNumber) {
            let selectedCustomer;

            if (document.forms['make-appointment-form'].elements.Shop.type.toLowerCase() === 'hidden') {
                // Channel marketing (hidden input field)
                selectedCustomer = document.forms['make-appointment-form'].elements.Shop;
            } else {
                // Regular website
                selectedCustomer = document.forms['make-appointment-form'].elements.Shop.querySelector(`[value="${customerNumber}"]`);
            }

            if (selectedCustomer !== null && selectedCustomer.hasAttribute('data-api') && selectedCustomer.getAttribute('data-api') === 'true') {
                this.showAppointmentTypes = true;
            } else {
                this.showAppointmentTypes = false;
            }

            if (this.showAppointmentTypes) {
                this.resetAppointment();
                this.getAppointmentTypes();
            }
        },
        'appointment.AppointmentTypeId': function (appointmentTypeId) {

            //const selectedAppointmentType = document.forms['make-appointment-form'].elements.AppointmentType.querySelector(`[value="${appointmentTypeId}"]`);
            //let appointmentTypeText = selectedAppointmentType !== null ? selectedAppointmentType.textContent : '';

            if (appointmentTypeId === '') {
                this.resetAppointment();
                this.showDatepicker = false;
                this.makeAppointment = false;
                this.appointment.AppointmentType = '';
            } else {

                let appointmentTypeText = '';

                for (let i = 0; i < this.appointmentTypes.length; i += 1) {
                    const ap = this.appointmentTypes[i];
                    if (ap.id === appointmentTypeId) {
                        appointmentTypeText = ap.name;
                        break;
                    }
                }

                this.showDatepicker = true;
                this.makeAppointment = true;
                this.appointment.AppointmentType = appointmentTypeText;

                this.availableTimes = [];
                this.appointment.Date = '';

                this.getBookableDays(appointmentTypeId);
            }
        },
        appointmentType(type) {
            if (type === document.forms['make-appointment-form'].elements.SetAppointmentType[0].value && this.appointment.CustomerNumber !== '') {
                this.makeAppointment = true;
                this.getBookableDays();
            } else {
                this.resetAppointment();
                this.makeAppointment = false;
            }
        },
        availableDays(days) {
            if (days.length > 0) {
                this.datepicker.set('disable', []);
                this.datepicker.set('enable', this.availableDays.map(d => d.date));
            } else {
                this.datepicker.set('enable', []);
                this.disableAllDays();
            }

            if (this.appointment.Date === '') {
                this.datepicker.setDate('', false);
            }
        },
        selectedTime: {
            handler(uid) {
                const time = this.availableTimes.filter(t => t.uniqueId === uid)[0];

                this.appointment.StartTime = time.startTime;
                this.appointment.EndTime = time.endTime;
                this.appointment.ResourceId = time.resourceId;
            },
            deep: true,
        },
    },
    methods: {
        initFormFill() {
            if (typeof Storage !== 'undefined') {
                if (localStorage.makeAppointmentForm === 'true') {
                    this.refillFormFields();
                }

                window.addEventListener('beforeunload', this.storeFormFields);
            }
        },
        refillFormFields() {
            // Only select form fields which have been marked to be stored
            const contactDetailsFieldsetInputs = document.forms['make-appointment-form'].querySelectorAll('.js-form__group__input--store');

            for (let i = 0; i < contactDetailsFieldsetInputs.length; i += 1) {
                const input = contactDetailsFieldsetInputs[i];
                let bFillValue = true;
                
                if ((input.type === 'select-one' && input.disabled) || input.readOnly ||
                    ((input.getAttribute('type') === 'hidden' || website.loggedIn || window.location.href.search("[?&]customerNumber=") !== -1) && input.getAttribute('name') === 'CustomerNumber')) {
                    bFillValue = false;
                }

                if (bFillValue) {
                    switch (input.tagName.toLowerCase()) {
                        case 'input':
                            switch (input.getAttribute('type')) {
                                case 'checkbox':
                                case 'radio':
                                    // The checkboxes on the form are not on the Vue model and if radio buttons were present each one within
                                    // a group would be iterated on here, therefore we cannot check the Vue model property based on ID
                                    if (localStorage[input.getAttribute('id')] === 'true') {
                                        input.checked = true;
                                    } else {
                                        input.checked = false;
                                    }
                                    break;

                                default:    // text, email, number, tel, etc.
                                    if (typeof this.appointment[input.getAttribute('name')] !== 'undefined') {
                                        this.appointment[input.getAttribute('name')] = localStorage[input.getAttribute('name')];
                                    } else {
                                        if (typeof localStorage[input.getAttribute('name')] !== 'undefined') {
                                            input.value = localStorage[input.getAttribute('name')];
                                        }
                                    }
                                    break;
                            }
                            break;

                        default:    // textarea, select
                            if (typeof this.appointment[input.getAttribute('name')] !== 'undefined') {
                                this.appointment[input.getAttribute('name')] = localStorage[input.getAttribute('name')];
                            } else {
                                input.value = localStorage[input.getAttribute('name')];
                            }
                            break;
                    }
                }

                if (input.getAttribute('name') === 'CustomerNumber') {
                    if (input.hasAttribute('data-value')) {
                        this.appointment.CustomerNumber = input.getAttribute('data-value');
                    } else {
                        //this.appointment.CustomerNumber = input.value;
                    }
                }
            }
        },
        storeFormFields() {
            if (localStorage.overridePrefillForm !== 'true') {
                // Only select form fields which have been marked to be stored
                const contactDetailsFieldsetInputs = document.forms['make-appointment-form'].querySelectorAll('.js-form__group__input--store');

                localStorage.makeAppointmentForm = true;

                for (let i = 0; i < contactDetailsFieldsetInputs.length; i += 1) {
                    const input = contactDetailsFieldsetInputs[i];

                    if (typeof input.value !== 'undefined') {
                        let bStoreValue = true;

                        if ((input.type === 'select-one' && input.disabled) || input.readOnly) {
                            bStoreValue = false;
                        }

                        if (bStoreValue) {
                            switch (input.tagName.toLowerCase()) {
                                case 'input':
                                    switch (input.getAttribute('type')) {
                                        case 'checkbox':
                                        case 'radio':
                                            if (input.checked) {
                                                localStorage[input.getAttribute('id')] = true;
                                            } else {
                                                localStorage[input.getAttribute('id')] = false;
                                            }
                                            break;

                                        default:    // text, email, number, tel, etc.
                                            localStorage[input.getAttribute('name')] = input.value;
                                            break;
                                    }
                                    break;

                                default:    // textarea, select
                                    localStorage[input.getAttribute('name')] = input.value;
                                    break;
                            }
                        }
                    }
                }
            } else {
                // Allow prefill next time as the unload event has passed meaning the prefill wasn't erroneously executed
                localStorage.removeItem('overridePrefillForm');
            }
        },
        unstoreFormFields() {
            // Only select form fields which have been marked to be stored
            const contactDetailsFieldsetInputs = document.forms['make-appointment-form'].querySelectorAll('.js-form__group__input--store');

            for (let i = 0; i < contactDetailsFieldsetInputs.length; i += 1) {
                const input = contactDetailsFieldsetInputs[i];

                switch (input.tagName.toLowerCase()) {
                    case 'input':
                        switch (input.getAttribute('type')) {
                            case 'checkbox':
                            case 'radio':
                                localStorage.removeItem(input.getAttribute('id'));
                                break;

                            default:    // text, email, number, tel, etc.
                                localStorage.removeItem(input.getAttribute('name'));
                                break;
                        }
                        break;

                    default:    // textarea, select
                        localStorage.removeItem(input.getAttribute('name'));
                        break;
                }
            }

            localStorage.makeAppointmentForm = false;
            localStorage.overridePrefillForm = true;
        },
        setFormFieldsReadonly() {
            const contactDetailsFieldsetInputs = document.forms['make-appointment-form'].elements;

            for (let i = 0; i < contactDetailsFieldsetInputs.length; i += 1) {
                const input = contactDetailsFieldsetInputs[i];

                if (typeof input.value !== 'undefined') {
                    if (input.type === 'select-one' && input.value !== '' && input.name !== 'CustomerNumber') {
                        input.disabled = true;
                        input.parentElement.classList.add('disabled');
                    }

                    if (input.value !== '') {
                        input.readOnly = true;
                    }
                }
            }
        },
        sortedShopName(shop) {
            if (shop.name.endsWith(shop.city)) {
                return `${shop.name} - (${shop.distance}km)`;
            } else {
                return `${shop.name} - ${shop.city} - (${shop.distance}km)`;
            }
        },
        sortShoplistByZipcode(e) {
            let sortShopList = false;
            const zipcode = e.target.value;

            if (!website.loggedIn /*&& this.appointment.CustomerNumber === ''*/) {
                sortShopList = true;
            }

            if (website.loggedIn &&
                (
                    !document.forms['make-appointment-form'].elements.PostalCode.readOnly /*&&
                    document.forms['make-appointment-form'].elements.CustomerNumber.value === ''*/
                )
            ) {
                sortShopList = true;
            }

            if (sortShopList && zipcode.length > 0) {
                fetch(`/api/geolocation/roomplannershops?zipcode=${zipcode}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': document.documentElement.lang,
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    credentials: 'same-origin',
                }).then(response => response.json()).then((shops) => {
                    this.appointment.CustomerNumber = '';
                    this.sortedShopList = shops;
                    this.resetAppointment();
                    Vue.nextTick(() => {
                        fInitCustomSelects();
                    });
                });
            }
        },
        disableAllDays() {
            let minDay = 1;
            let minMonth = (this.datepicker.currentMonth);
            let maxMonth = minMonth;
            let minYear = this.datepicker.currentYear;
            let maxYear = minYear;

            const minDateElem = this.datepicker.days.firstElementChild;

            if (minDateElem.classList.contains('prevMonthDay')) {
                minDay = parseInt(minDateElem.textContent, 10);
                minMonth -= 1;
            }

            const maxDateElem = this.datepicker.days.lastElementChild;

            if (maxDateElem.classList.contains('nextMonthDay')) {
                maxMonth += 1;
            }

            if (minDateElem.getAttribute('aria-label').indexOf(minYear) === -1) {
                minYear -= 1;
            }

            if (maxDateElem.getAttribute('aria-label').indexOf(maxYear) === -1) {
                maxYear += 1;
            }

            const firstDay = new Date(minYear, minMonth, minDay);
            const lastDay = new Date(maxYear, maxMonth, parseInt(maxDateElem.textContent, 10));

            this.datepicker.set('disable', [
                {
                    from: firstDay,
                    to: lastDay,
                },
            ]);
        },
        getAppointmentTypes() {
            this.unavailableError = false;

            fetch(`/api/agenda/roomplannerappointmenttypes?customerNumber=${this.appointment.CustomerNumber}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': document.documentElement.lang,
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    credentials: 'same-origin'
                })
                .then(response => response.json()).then((appointmentTypesResponse) => {
                    this.appointmentTypes = appointmentTypesResponse;

                    if (this.appointmentTypes.length === 1) {
                        this.appointment.AppointmentTypeId = this.appointmentTypes[0].id;
                    }

                    Vue.nextTick(() => {
                        fInitCustomSelects();
                    });
                });
            
        },
        getBookableDays(appTypeId) {
            this.unavailableError = false;

            if (typeof appTypeId === 'undefined') {
                appTypeId = -1;
            }

            fetch(`/api/agenda/bookabledays?customerNumber=${this.appointment.CustomerNumber}&appointmentType=${appTypeId}&year=${this.datepicker.currentYear}&month=${this.datepicker.currentMonth + 1}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': document.documentElement.lang,
                    'X-Requested-With': 'XMLHttpRequest'
                },
                credentials: 'same-origin'
            })
            .then(response => response.json()).then((bookableDaysResponse) => {
                this.availableDays = bookableDaysResponse;

            });
            
        },
        getBookableTimes(agendaId, date, appointmentTypeId) {
            this.unavailableError = false;

            fetch(`/api/agenda/bookabletimes?customerNumber=${this.appointment.CustomerNumber}&agendaId=${agendaId}&date=${date}&appointmentTypeId=${appointmentTypeId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': document.documentElement.lang,
                    'X-Requested-With': 'XMLHttpRequest'
                },
                credentials: 'same-origin',
            })
            .then(response => response.json()).then((bookableTimesResponse) => {
                // Get objects with unique startTime
                this.availableTimes = bookableTimesResponse.filter((t, i) => bookableTimesResponse.findIndex(b => b.startTime === t.startTime) === i);

                Vue.nextTick(() => {
                    fInitCustomSelects();
                });
            });
            
        },
        resetAppointment() {
            this.unavailableError = false;
            this.appointment.AgendaId = '';
            this.appointment.AppointmentTypeId = '';
            this.appointment.Date = '';
            this.appointment.StartTime = '';
            this.appointment.EndTime = '';
            this.appointment.ResourceId = null;
        },
        scrollIntoView() {
            //window.location.href = "#questionlist";

            var el = document.getElementById('questionlist');
            el.scrollIntoView();
            window.scrollBy(0, -95);

        },
        prevQuestion(event) {

            if (event) {
                event.preventDefault();
            }

            if (this.showOverview) {
                this.showOverview = false;
            } else {
                this.currentQuestion -= 1;
            }

            this.scrollIntoView();
        },
        nextQuestion(event) {

            if (event) {
                event.preventDefault();
            }

            if (this.currentQuestion <= this.checklistQuestions.length) {
                this.currentQuestion += 1;
            }
            this.showOverview = false;
            this.scrollIntoView();
        },
        showOverviewButton(event) {

            if (event) {
                event.preventDefault();
            }

            this.showOverview = true;

            this.scrollIntoView();
        },
        expandCollapse(event) {
            /*
            var el = document.getElementById('questionlistquestions');
            console.log(el.clientHeight);
            if (el.clientHeight > 0) {
                el.style.height = 0;
            }*/

            if (event) {
                event.preventDefault();
            }

            this.scrollIntoView();
        },
        gotoQuestion(question, index) {
            if (question.givenAnswer || index < this.currentQuestion) {
                this.currentQuestion = index + 1;
            }

            this.showOverview = false;
        },
        answerString(question) {

            if (question.givenAnswer) {
                return question.options.filter(t => t.id === question.givenAnswer)[0].title;
            }
            else if (question.givenAnswerMulti && question.givenAnswerMulti.length > 0) {

                var s = "";
                question.givenAnswerMulti.forEach((q) => {
                    s += question.options.filter(t => t.id === q)[0].title + ", ";
                });

                return s.replace(/,\s+$/, "");
                
            }

            return "-";
        }
    },
});